(function () {
  var viewer = document.querySelector('[data-ag-photo-viewer]');
  var root = document.querySelector('[data-gallery]');
  if (!viewer || !root || viewer.dataset.ready) return;
  viewer.dataset.ready = 'true';
  var photos = Array.from(root.querySelectorAll('[data-lightbox-src]'));
  var image = viewer.querySelector('[data-ag-photo-image]');
  var count = viewer.querySelector('[data-ag-photo-count]');
  var index = 0;
  var opener;
  function show(i) {
    index = (i + photos.length) % photos.length;
    image.src = photos[index].dataset.full || photos[index].currentSrc;
    image.alt = photos[index].alt;
    count.textContent = (index + 1) + ' / ' + photos.length;
  }
  function open(i) { opener = photos[i]; show(i); viewer.showModal(); }
  function close() { viewer.close(); if (opener) opener.focus(); }
  photos.forEach(function (photo, i) {
    photo.addEventListener('click', function () { open(i); });
    photo.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(i); }
    });
  });
  viewer.querySelector('[data-ag-photo-close]').addEventListener('click', close);
  viewer.querySelector('[data-ag-photo-prev]').addEventListener('click', function () { show(index - 1); });
  viewer.querySelector('[data-ag-photo-next]').addEventListener('click', function () { show(index + 1); });
  viewer.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
  });
  viewer.addEventListener('click', function (event) { if (event.target === viewer) close(); });
})();
